<div class="duplicatas-resumo">
  <div class="duplicatas-indicador">
    <span class="duplicatas-label">TOTAL DE DUPLICATAS</span>
    <strong class="duplicatas-numero">{{ notasFiscais?.length || 0 }}</strong>
  </div>
  <div class="duplicatas-indicador duplicatas-valor">
    <span class="duplicatas-label">VALOR TOTAL</span>
    <strong class="duplicatas-numero">{{ valorTotal | currency: 'BRL' }}</strong>
  </div>
</div>
@if (valoresNaoInformados > 0) {
  <p class="text-muted small">{{ valoresNaoInformados }} duplicata(s) sem valor informado; não incluídas no valor total.</p>
}
<div class="table-responsive">
  <table class="table table-sm pedido-modal-notas-fiscais-tabela" aria-label="Duplicatas do cliente">
    <thead>
      <tr>
        <th scope="col">Número NF</th>
        <th scope="col">Série NF</th>
        <th scope="col">Sequência</th>
        <th scope="col">Cód. emp.</th>
        <th scope="col" class="text-right">Valor</th>
        <th scope="col" class="text-right">Vencimento</th>
      </tr>
    </thead>

    <tbody>
      @for (notaFiscal of notasFiscais; track notaFiscal.id) {
        <tr>
          <td class="duplicatas-nf" data-label="Número NF">{{ notaFiscal.numero_nf || notaFiscal.nro_notafiscal || '—' }}</td>
          <td data-label="Série NF">{{ notaFiscal.serie_nf || '—' }}</td>
          <td data-label="Sequência">{{ notaFiscal.sequencia || '—' }}</td>
          <td data-label="Cód. emp.">{{ notaFiscal.codemp || '—' }}</td>
          <td class="text-right" data-label="Valor">{{ notaFiscal.valor == null ? '—' : (notaFiscal.valor | currency: 'BRL') }}</td>
          <td class="text-right" data-label="Vencimento">{{ notaFiscal.vencimento == null ? '—' : (notaFiscal.vencimento | date: 'dd/MM/yyyy') }}</td>
        </tr>
      }
      @empty {
        <tr><td colspan="6" class="text-center text-muted">Nenhuma duplicata encontrada.</td></tr>
      }
    </tbody>
  </table>
</div>
